import { render, staticRenderFns } from "./MasterNewDataView.vue?vue&type=template&id=17c395a6&"
import script from "./MasterNewDataView.vue?vue&type=script&lang=js&"
export * from "./MasterNewDataView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports